export default __webpack_public_path__ + "static/media/empty_person.3b4adf09.svg";